import { useRuntimeConfig } from '@xing-com/crate-xinglet/internal';

export const useIsCoverLetterRoot = (): boolean => {
  const { entryPoint } = useRuntimeConfig();

  return entryPoint === '@xing-com/crate-anschreiben-entrypoint';
};
